import React, { useState, useEffect } from 'react';
import {
    Alert,
    Container,
    Header as HeaderRS,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import {
    Header,
    Form,
    Button,
    Segment,
    Icon,
    //Dropdown,
    Divider } from 'semantic-ui-react';
import { api } from '../../../services/api';


import Navbarr from '../../../components/Navbar';

export default function ComptCreate({ sidebar: Sidebar}) {
    const [prodStates, setProdStates] = useState({
        route: {},
        formProd: {
            nome: '',
            lojas: [],
            proprios: []
        },
        //propOptions: [],
        isLoading: false
    });


    const resetProdStates = () => {
        setProdStates( prevState => ({
            ...prevState,
            formProd: {
                nome: '',
                lojas: [],
                proprios: []
            },
            proprOptions: [],
            isLoading: false
        }));
    }

    const handleNomeChange = (e, {value}) => {
        setProdStates( prevState => ({
            ...prevState,
            formProd: {
                ...prevState['formProd'],
                nome: value
            }
        }));
    }

    /*const handlePropChange = (e, {value}) => {
        setProdStates((prevState) => ({
            ...prevState,
            formProd: {
                ...prevState['formProd'],
                proprios: value
            }
        }));
    }*/

    async function handlePost() {
        try {
            setProdStates( prevState => ({
                ...prevState,
                isLoading: true,
            }));
            const proprios = [];

            prodStates['formProd']['proprios'].forEach(
                pp => proprios.push({'id':pp})
            );

            /*const data = */await api.postCompProduct(prodStates['formProd']['nome'],
                                            proprios);
            Alert.success("Competidor cadastrado com sucesso!");
            resetProdStates();
        } catch (err) {
            Alert.error("Falha ao cadastrar competidor. Verifique os campos e tente novamente.");
            console.error('Falha ao cadastrar competidor: ', err);
            setProdStates( prevState=> ({
                ...prevState,
                isLoading: false,
            }));
        }
    }

    useEffect(() => {
        async function fetchProp() {
            try {
                const proprOptions = [];
                const data = await api.getOwnProducts();
                data.forEach(
                    pp => {
                        proprOptions.push({key: pp['id'],
                                            text: pp['nome'],
                                            value: pp['id']});
                    }
                );
                setProdStates(prevState => ({
                    ...prevState,
                    proprOptions: proprOptions,
                }));
            } catch (err) {
                console.error('Falha ao obter proprios: ', err);
            }
        }
        fetchProp();
    },[]);

    return (
        <Container>
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"comptnew"}></Sidebar>
            </Side>
            <Container>
                <HeaderRS>
                    <Navbarr></Navbarr>
                </HeaderRS>
                <Content style={{ backgroundColor: '#FAFAFA', padding: '5px'}}>
                    <div>
                        <Segment loading={prodStates['isLoading']}>
                            <Header as='h3' floated='left'>
                                Novo Competidor
                            </Header>

                            <Divider clearing />
                            Preencha os campos com as informações do competidor
                            <Form style={{marginTop: '15px'}}>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            iconPosition='left'
                                            icon='coffee'
                                            fluid label='Nome'
                                            placeholder='Nome'
                                            value={prodStates['formProd']['nome']}
                                            onChange={handleNomeChange}
                                        />
                                    </Form.Group>

                                    <Form.Group>
                                        <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            primary
                                            size="mini"
                                            floated='right'
                                            onClick={handlePost}
                                            type='submit'>
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='save'/> Salvar
                                                </div>
                                        </Button>
                                    </Form.Group>
                                </Form>
                            </Segment>
                        </div>
                    </Content>
                <Footer></Footer>
            </Container>
        </Container>
    );
}
